// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.update-header {
  font-weight: 400;
  font-size: 20px;
  line-height: 40px;
  margin-left: 10px;
  margin-top: 50px;
  color: #333;
}

.form-groupUp {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 30px;
  margin-left: 0px;
}

.UpDate {
  margin-left: 10px !important;
  padding: 8px 12px !important;
  border: 1px solid #ddd !important;
  border-radius: 5px !important;
  font-size: 16px !important;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1) !important;
  transition: border-color 0.2s ease-in-out !important;
}

.UpDate:focus {
  border-color: #007bff;
  outline: none;
}

.buttons-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
}

.map-button {
  padding: 10px 20px;
  background-color: #03a1ea;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  margin: 0 10px;
  transition: background-color 0.3s ease;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}

.map-button:hover {
  background-color: #07a6ef;
}

.error-message {
  color: red;
  margin-left: 10px;
  text-align: center;
  font-size: 16px;
}

h4 {
  /* text-align: center; */
  margin-top: 20px;
}

#map-0 {
  margin-top: 20px;
  width: 90%;
  height: 500px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 10px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/Css/Update.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,iCAAiC;EACjC,6BAA6B;EAC7B,0BAA0B;EAC1B,qDAAqD;EACrD,oDAAoD;AACtD;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;AAC7C","sourcesContent":[".update-header {\r\n  font-weight: 400;\r\n  font-size: 20px;\r\n  line-height: 40px;\r\n  margin-left: 10px;\r\n  margin-top: 50px;\r\n  color: #333;\r\n}\r\n\r\n.form-groupUp {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-top: 20px;\r\n  margin-bottom: 30px;\r\n  margin-left: 0px;\r\n}\r\n\r\n.UpDate {\r\n  margin-left: 10px !important;\r\n  padding: 8px 12px !important;\r\n  border: 1px solid #ddd !important;\r\n  border-radius: 5px !important;\r\n  font-size: 16px !important;\r\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1) !important;\r\n  transition: border-color 0.2s ease-in-out !important;\r\n}\r\n\r\n.UpDate:focus {\r\n  border-color: #007bff;\r\n  outline: none;\r\n}\r\n\r\n.buttons-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.map-button {\r\n  padding: 10px 20px;\r\n  background-color: #03a1ea;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 5px;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  margin: 0 10px;\r\n  transition: background-color 0.3s ease;\r\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.map-button:hover {\r\n  background-color: #07a6ef;\r\n}\r\n\r\n.error-message {\r\n  color: red;\r\n  margin-left: 10px;\r\n  text-align: center;\r\n  font-size: 16px;\r\n}\r\n\r\nh4 {\r\n  /* text-align: center; */\r\n  margin-top: 20px;\r\n}\r\n\r\n#map-0 {\r\n  margin-top: 20px;\r\n  width: 90%;\r\n  height: 500px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  border-radius: 10px;\r\n  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
